module.exports = "/packs/media/images/divorce-6fc1bc112f0d73a5af4abb3bae4c4266.png";